import axios from "axios";
import { API_URL } from "../Common/Constant";

class SanctionCountry {

    addSanctionCountryLog(userId, planId, sourceId) {
        return axios.post(`${API_URL}/webappapi/addSanctionCountryLog`, {}, { headers: { "planId": planId, "sourceId": sourceId, "userId": userId } });
    }
}

export default new SanctionCountry()
